<div class="container">

    <app-header></app-header>
    
    <div class="content">
        <router-outlet></router-outlet>
    </div>

    <!-- without the footer, .content fills the viewport so the loading state takes the whole page -->
    @if (!isPageLoading()) {
        <app-layout-footer></app-layout-footer>
    }
</div>
